import { t } from "@lingui/core/macro";

export function getControlPointValue(idx: string) {
  const controlPointValues = {
    210: t`Heating set value`,
    211: t`Cooling set value`,
    212: t`Cooling dead zone`,
    213: t`Heating battery return water OFF state set value`,
    214: t`Heating battery return water ON state limit setvalue`,
    215: t`Active set value (read only)`,
    216: t`Output value of point 0..100% (read only)`,
    217: t`Heating battery return water OFF state P-band`,
    218: t`Heating battery return water ON state limit P-band`,
    // Stage-1
    250: t`name (read only)`,
    251: t`P band (read only)`,
    252: t`outdoor temp limit set value`,
    253: t`outdoor temp limit P band`,
    254: t`output minimum value`,
    255: t`output maximum value`,
    256: t`OFF state value`,
    257: t`value`,
    259: t`limit set value`,
    260: t`limit P band`,
    // Stage 2
    265: t`name (read only)`,
    266: t`P band (read only)`,
    267: t`outdoor temp limit set value`,
    268: t`outdoor temp limit P band`,
    269: t`output minimum value`,
    270: t`output maximum value`,
    271: t`OFF state value`,
    272: t`value`,
    274: t`limit set value`,
    275: t`limit P band`,
    // Stage 3
    280: t`name (read only)`,
    281: t`P band (read only)`,
    282: t`outdoor temp limit set value`,
    283: t`outdoor temp limit P band`,
    284: t`output minimum value`,
    285: t`output maximum value`,
    286: t`OFF state value`,
    287: t`value`,
    289: t`limit set value`,
    290: t`limit P band`,
    // Stage 4
    295: t`name (read only)`,
    296: t`P band (read only)`,
    297: t`outdoor temp limit set value`,
    298: t`outdoor temp limit P band`,
    299: t`output minimum value`,
    300: t`output maximum value`,
    301: t`OFF state value`,
    302: t`value`,
    304: t`limit set value`,
    305: t`limit P band`,
    // Stage 5
    310: t`name (read only)`,
    311: t`P band (read only)`,
    312: t`outdoor temp limit set value`,
    313: t`outdoor temp limit P band`,
    314: t`output minimum value`,
    315: t`output maximum value`,
    316: t`OFF state value`,
    317: t`value`,
    319: t`limit set value`,
    320: t`limit P band`,
    // Stage 6
    325: t`name (read only)`,
    326: t`P band (read only)`,
    327: t`outdoor temp limit set value`,
    328: t`outdoor temp limit P band`,
    329: t`output minimum value`,
    330: t`output maximum value`,
    331: t`OFF state value`,
    332: t`value`,
    334: t`limit set value`,
    335: t`limit P band`,
    340: t`Operating mode of control point (read only)`,
  };
  return controlPointValues[idx];
}
